export default "/images/vendor/flag-icons/flags/4x3/ht.svg?7388c69479f3b8d12dfa2ab73a9f926c";